import { CurrencyEurIcon } from './CurrencyEurIcon';

/**
 * author: Google
 * id 94C667B3-E2EB-428D-B422-751C234CCF44
 * name currency-eur
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-eur.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const EuroIcon = CurrencyEurIcon;
export default EuroIcon